import React, { useState, useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { Toast } from "primereact/toast";
//
function AddCustomerCutModel(props) {
  const toast = useRef(null);

  const show = props.show;
  const setShow = props.setShow;
  const setCounter = props.setCounter;
  const counter = props.counter;

  const today = new Date().toLocaleDateString("en-CA");

  const user = JSON.parse(sessionStorage.getItem("user-data"));
  const user_id = user["encrypted_id"];

  const {
    errorCuts,
    isLoading: isLoadingCuts,
    data: cuts,
  } = useFetch(`${main_link}getAllCutsStyles?user_id=${user_id}`, counter);

  const hair = cuts ? cuts.filter((c) => c.type === "Hair") : [];
  const face = cuts ? cuts.filter((c) => c.type === "Face") : [];
  const beard = cuts ? cuts.filter((c) => c.type === "Beard") : [];

  const {
    errorCustomers,
    isLoading: isLoadingCustomers,
    data: cust,
  } = useFetch(`${main_link}getAllCustomer?user_id=${user_id}`, counter);
  const customers = cust ? cust : [];

  const [isLoading, setIsLoading] = useState(false);
  const [custID, setCustID] = useState();
  const [hairID, setHairID] = useState();
  const [beardID, setBeardID] = useState();
  const [faceID, setFaceID] = useState();
  const [fPrice, setFPrice] = useState();
  const [bPrice, setBPrice] = useState();
  const [hPrice, setHPrice] = useState();
  const [notes, setNotes] = useState();

  const submit = async (e) => {
    //
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(main_link + "addCustomerCut", {
        user_id,
        custID: custID?.value,
        hairID: hairID?.value,
        beardID: beardID?.value,
        faceID: faceID?.value,
        fPrice,
        bPrice,
        hPrice,
        notes,
      });
      if (response.data.message == "Added Successfully.") {
        setCounter(counter + 1);
        setIsLoading(false);
        $("#addNewCutModel").modal("hide");
        resetValues();
        document.getElementById("customersCuts").reset();
        toast.current.show({
          severity: "success",
          summary: "success",
          detail: "Added Successfully.",
        });
      }
    } catch (e) {
      setIsLoading(false);

      // Check if the response contains validation errors
      if (e.response && e.response.data.errors) {
        const errors = e.response.data.errors;

        // Log all errors dynamically
        Object.keys(errors).forEach((key) => {
          // console.log(errors[key]);

          // Display the error using toast
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errors[key], // Show the corresponding error message
          });
        });
      } else {
        // Log or handle other types of errors
        console.log("An unexpected error occurred:", e);
      }
    }
  };

  const clearCustomer = useRef();
  const clearBeard = useRef();
  const clearFace = useRef();
  const clearHair = useRef();

  const resetValues = () => {
    setCustID("");
    setHairID("");
    setBeardID("");
    setFaceID("");
    setFPrice("");
    setBPrice("");
    setHPrice("");
    setNotes("");

    clearCustomer.current.clearValue();
    clearBeard.current.clearValue();
    clearFace.current.clearValue();
    clearHair.current.clearValue();
  };

  return (
    <>
      <Toast ref={toast} />
      <div
        className="modal fade"
        id="addNewCutModel"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Cut Details
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <Form id="customersCuts">
                <Row>
                  <Col lg={6} sm={6}>
                    <div className="form-group">
                      <label htmlFor="inputName">
                        Select Customer{" "}
                        {isLoadingCustomers && (
                          <Spinner
                            size="sm"
                            animation="border"
                            role="status"
                          ></Spinner>
                        )}
                      </label>
                      {customers && (
                        <Select
                          ref={clearCustomer}
                          onChange={setCustID}
                          placeholder="Select Customer"
                          options={
                            customers &&
                            customers.map((item) => ({
                              label: item.name,
                              value: item.cust_id,
                            }))
                          }
                        />
                      )}
                    </div>
                  </Col>
                  <Col lg={6} sm={6}>
                    <div className="form-group">
                      <label htmlFor="inputName">Today</label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputName"
                        placeholder="Full Name"
                        disabled
                        value={today}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} sm={6}>
                    <div className="form-group">
                      <label htmlFor="inputName">
                        Hair{" "}
                        {isLoadingCuts && (
                          <Spinner
                            size="sm"
                            animation="border"
                            role="status"
                          ></Spinner>
                        )}
                      </label>
                      {hair && (
                        <Select
                          ref={clearHair}
                          onChange={setHairID}
                          options={hair.map((item) => ({
                            label: item.name,
                            value: item.cut_id,
                          }))}
                          placeholder="Select Hair Style"
                        />
                      )}
                    </div>
                  </Col>
                  <Col lg={4} sm={6}>
                    <div className="form-group">
                      <label htmlFor="inputName">
                        Beard{" "}
                        {isLoadingCuts && (
                          <Spinner
                            size="sm"
                            animation="border"
                            role="status"
                          ></Spinner>
                        )}
                      </label>
                      {beard && (
                        <Select
                          ref={clearBeard}
                          onChange={setBeardID}
                          options={beard.map((item) => ({
                            label: item.name,
                            value: item.cut_id,
                          }))}
                          placeholder="Select Beard Style"
                        />
                      )}
                    </div>
                  </Col>
                  <Col lg={4} sm={6}>
                    <div className="form-group">
                      <label htmlFor="inputName">
                        Face{" "}
                        {isLoadingCuts && (
                          <Spinner
                            size="sm"
                            animation="border"
                            role="status"
                          ></Spinner>
                        )}
                      </label>
                      {face && (
                        <Select
                          ref={clearFace}
                          onChange={setFaceID}
                          options={face.map((item) => ({
                            label: item.name,
                            value: item.cut_id,
                          }))}
                          placeholder="Select Face Style"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} sm={6}>
                    {" "}
                    <div className="form-group">
                      <label htmlFor="inputName">Hair Price $</label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputName"
                        placeholder="Hair Price "
                        onChange={(e) => setHPrice(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col lg={4} sm={6}>
                    {" "}
                    <div className="form-group">
                      <label htmlFor="inputName">Beard Price $</label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputName"
                        placeholder="Beard Price "
                        onChange={(e) => setBPrice(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col lg={4} sm={6}>
                    {" "}
                    <div className="form-group">
                      <label htmlFor="inputName">Face Price $</label>
                      <input
                        type="text"
                        className="form-control"
                        id="inputName"
                        placeholder="Face Price"
                        onChange={(e) => setFPrice(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {" "}
                    <div className="form-group">
                      <label htmlFor="inputName">Notes</label>
                      <textarea
                        type="textarea"
                        className="form-control"
                        id="inputName"
                        placeholder="Any Notes Here"
                        rows={3}
                        onChange={(e) => setNotes(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              {isLoading && (
                <button type="button" className="btn btn-primary" disabled>
                  Loading ...
                </button>
              )}
              {!isLoading && (
                <button
                  type="button"
                  onClick={(e) => submit(e)}
                  className="btn btn-primary"
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddCustomerCutModel;
